import { useState } from "react";
import "../styles/CpfValidationModal.css";
import useValidateCpf from "../hooks/useValidateCpf";

function CpfValidationModal({ onValidationSuccess }) {
  const [cpf, setCpf] = useState("");
  const { validateCpf, loading, error, clearError } = useValidateCpf();

  const formatCpf = (value) => {
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 11) {
      return cleaned
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }
    return value;
  };

  const handleCpfChange = (e) => {
    const formatted = formatCpf(e.target.value);
    setCpf(formatted);
    clearError();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await validateCpf(cpf);

    if (result.success) {
      onValidationSuccess();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">Validação de Acesso</h2>
        <p className="modal-subtitle">
          Informe seu CPF para acessar o agendamento
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="cpf" className="form-label">
              CPF
            </label>
            <input
              id="cpf"
              type="text"
              value={cpf}
              onChange={handleCpfChange}
              placeholder="000.000.000-00"
              maxLength="14"
              className={`form-input ${error ? "form-input-error" : ""}`}
            />
            {error && <p className="error-message">{error}</p>}
          </div>

          <button
            type="submit"
            disabled={loading || cpf.length < 14}
            className={`submit-button ${
              loading || cpf.length < 14 ? "submit-button-disabled" : ""
            }`}
          >
            {loading ? "Validando..." : "Enviar"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CpfValidationModal;
